import React from "react";

const SkipButton = ({ text = "Skip", onClick, className = "" }) => {

  const handleSkip = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      className={`btn btn-skip ${className}`}
      onClick={handleSkip}
    >
      {text}
    </button>
  );
};

export default SkipButton;